// Single source of truth for the localStorage keys that hold admin session
// state. Used by both api.ts's force-relogin redirect (on a 401 from any
// non-login route) and Layout.tsx's logout button, so the two paths can
// never drift apart on what counts as "signed out".
export const AUTH_STORAGE_KEYS = ['authToken', 'authHeader', 'user'] as const;

export function clearAuthStorage(): void {
  for (const key of AUTH_STORAGE_KEYS) {
    localStorage.removeItem(key);
  }
}
